<input
  nbInput
  [fullWidth]="fullWidth"
  [(colorPicker)]="color"
  [style.background]="color"
  [cpWidth]="width"
  [cpHeight]="height"
  [cpToggle]="isToggle"
  [cpDisabled]="isDisabled"
  [cpColorMode]="colorMode"
  [cpCmykEnabled]="isCmyk"
  [cpOutputFormat]="defaultFormat"
  [cpAlphaChannel]="alphaChannel"
  [cpFallbackColor]="fallbackColor"
  [cpPosition]="position"
  [cpPositionOffset]="valuePositionOffset"
  [cpPresetLabel]="presetLabel"
  [cpPresetColors]="presetColors"
  (colorPickerOpen)="colorPickerOpen.emit($event)"
  (colorPickerClose)="colorPickerClose.emit($event)"
  (colorPickerChange)="colorPickerChange.emit($event)"
  (colorPickerCancel)="colorPickerCancel.emit($event)"
  (colorPickerSelect)="colorPickerSelect.emit($event)"
  (cpToggleChange)="toggleChange.emit($event)"
  (cpInputChange)="inputChange.emit($event)"
  (cpSliderChange)="sliderChange.emit($event)"
  (cpSliderDragStart)="sliderDragStart.emit($event)"
  (cpSliderDragEnd)="sliderDragEnd.emit($event)"
  (cpCmykColorChange)="cmykColorChange.emit($event)"
/>
